import {checkObjProps} from '../../utils/genericUtils'
import {INotification} from '../common/SXTNotification/SXTNotification.d'
import {RawNotification} from '../NotificationCenter/Notification.dto'

const type = {
  field_wiki_comments: '/wiki/',
  field_thinktank_comments: '/think-tank/feed/',
  field_comment_news: '/news/',
  field_social_comments: '/socialnews/',
  field_airline_comments: '/airline/',
  field_hotel_comments: '/hotel/',
  default: '/node/',
}
export const fetchNotifications = (
  rawNotifications: RawNotification[]
): INotification[] => {
  const allNotifications: INotification[] = []

  const formatNotificationObject = (
    item: RawNotification,
    redirectionURL: string,
    isYourContent = false
  ): INotification => {
    return {
      category: 'Sixtbook Tagged',
      description:
        '<b>' +
        item.author.fieldFirstName +
        ' ' +
        item.author.fieldLastName +
        (isYourContent
          ? '</b> commented on your content'
          : '</b> mentioned you in a conversation'),
      isRead: item.stateRead || false,
      entityId: item.entityId,
      redirectionURL,
      submittedDate: item.entityCreated,
      submitterCitrixId: item.author.name,
      submittedBy: undefined,
      typeOfNotification: 'Content',
      id: item.entityId,
      icon: '',
      tag: undefined,
    }
  }
  rawNotifications.forEach((item: RawNotification) => {
    switch (item.entityBundle) {
      case 'mention_created': {
        let redirectionURL = ''
        const mentionedEntityId = checkObjProps(item, [
          'sixtMention',
          'entity',
          'mentionOnEntityId',
          'entity',
          'entityIdOfComment',
          'entity',
          'entityId',
        ])
        if (mentionedEntityId) {
          redirectionURL =
            window.location.origin +
            type[
              checkObjProps(
                item,
                [
                  'sixtMention',
                  'entity',
                  'mentionOnEntityId',
                  'entity',
                  'fieldName',
                ],
                'default'
              )
            ] +
            mentionedEntityId
        }
        const notificationObj = formatNotificationObject(item, redirectionURL)
        allNotifications.push(notificationObj)
        break
      }
      case 'comment_created:comment': {
        let redirectionURL = ''
        const mentionedEntityId = checkObjProps(item, [
          'comment',
          'entity',
          'entityIdOfComment',
          'entity',
          'entityId',
        ])
        if (mentionedEntityId) {
          redirectionURL =
            window.location.origin +
            type[
              checkObjProps(item, ['comment', 'entity', 'fieldName'], 'default')
            ] +
            mentionedEntityId
        }
        const notificationObj = formatNotificationObject(
          item,
          redirectionURL,
          true
        )
        allNotifications.push(notificationObj)
        break
      }
    }
  })
  return allNotifications.sort(
    (e1, e2) =>
      new Date(e2.submittedDate).getTime() -
      new Date(e1.submittedDate).getTime()
  )
}
